"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setSubDomain = exports.setLogoLink = exports.setPrimaryColor = exports.getMetaDescription = exports.getMasterConfig = exports.configFallback = void 0;
exports.configFallback = {
    subDomain: "verified.sertifier.com",
    customDomain: "https://verified.sertifier.com",
    logoLink: "https://verified.sertifier.com/images/verified-logo.png",
    faviconLink: "https://verified.sertifier.com/favicon-32x32.png",
    socials: [],
    contactEmail: "",
    headerButtonUrl: "https://verified.sertifier.com",
    logoRedirectUrl: "https://verified.sertifier.com",
    customCSS: "",
    pageTitle: "Verified",
    organizationName: "Verified",
    metaDescription: "%organizationName% | All your digital credentials are in one place",
    metaImage: "https://verified.sertifier.com/images/verified-meta.png",
    primaryColor: "#006CE0",
    dummyColor: "#ff0000",
    headerTitle: "Certificate Library",
    headerColor: "#3C3C3B",
    headerBackgroundColor: "#fbfbfb",
    ctaText: "Visit Website",
    headerButtonBackgroundColor: "#006CE0",
    headerButtonTextColor: "#3C3C3B",
    headerText: "Credential Verification",
    website: "",
    recipientCardBackgroundColor: "#192541",
    recipientCardTextColor: "#ffffff",
    recipientCardButtonColor: "#006CE0",
    recipientCardButtonTextColor: "#ffffff",
    issuerCardBackgroundColor: "#F7F9FF",
    issuerCardTextColor: "#3C3C3B",
    issuerCardButtonColor: "#006CE0",
    issuerCardButtonTextColor: "#ffffff",
    downloadButtonColor: "#006CE0",
    downloadButtonTextColor: "#ffffff",
    skillTagColor: "#ffffff",
    skillTagTextColor: "#006CE0",
    footerBackgroundColor: "#ffffff",
    footerTextColor: "#3c3c3b",
    headerTextColor: "#3c3c3b",
    landingPageSearchSectionBackgroundColor: "#ffffff",
    headerMenu: [],
    footerMenu: [],
    containerBackgroundColor: "#F9F9F9",
    containerTextColor: "#000000",
};
const getMasterConfig = () => {
    return localStorage.getItem("masterConfig") != null &&
        localStorage.getItem("masterConfig") !== "null" &&
        localStorage.getItem("masterConfig") !== "undefined"
        ? JSON.parse(localStorage.getItem("masterConfig").replace(/`/g, '"'))
        : exports.configFallback;
};
exports.getMasterConfig = getMasterConfig;
const getMetaDescription = (configData) => {
    return !configData.metaDescription ||
        configData.metaDescription === exports.configFallback.metaDescription
        ? exports.configFallback.metaDescription.replace("%organizationName%", configData.organizationName)
        : configData.metaDescription;
};
exports.getMetaDescription = getMetaDescription;
const setPrimaryColor = (color, isWhitelabel) => {
    const config = (0, exports.getMasterConfig)();
    if (!isWhitelabel || !config.primaryColor) {
        config.primaryColor = color;
    }
    localStorage.setItem("masterConfig", JSON.stringify(config));
};
exports.setPrimaryColor = setPrimaryColor;
const setLogoLink = (logoLink) => {
    const config = (0, exports.getMasterConfig)();
    config.logoLink = logoLink;
    localStorage.setItem("masterConfig", JSON.stringify(config));
};
exports.setLogoLink = setLogoLink;
const setSubDomain = (subDomain) => {
    const config = (0, exports.getMasterConfig)();
    config.subDomain = subDomain;
    localStorage.setItem("masterConfig", JSON.stringify(config));
};
exports.setSubDomain = setSubDomain;
